import { render, staticRenderFns } from "./LoginRegisterPage.vue?vue&type=template&id=11c46d63&scoped=true&"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterPage.vue?vue&type=style&index=0&id=11c46d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c46d63",
  null
  
)

export default component.exports